/**
 * GoodLeap loan-share form: state list + helpers (parity with ContactManageModal / Trinity oneBUTTON master data).
 */

export type StateOption = { value: string; label: string };

/** US states when `opportunityinfoMasterData.StatesFullName` is missing or empty. */
export const US_STATE_FALLBACK: StateOption[] = `AL:Alabama;AK:Alaska;AZ:Arizona;AR:Arkansas;CA:California;CO:Colorado;CT:Connecticut;DE:Delaware;FL:Florida;GA:Georgia;HI:Hawaii;ID:Idaho;IL:Illinois;IN:Indiana;IA:Iowa;KS:Kansas;KY:Kentucky;LA:Louisiana;ME:Maine;MD:Maryland;MA:Massachusetts;MI:Michigan;MN:Minnesota;MS:Mississippi;MO:Missouri;MT:Montana;NE:Nebraska;NV:Nevada;NH:New Hampshire;NJ:New Jersey;NM:New Mexico;NY:New York;NC:North Carolina;ND:North Dakota;OH:Ohio;OK:Oklahoma;OR:Oregon;PA:Pennsylvania;RI:Rhode Island;SC:South Carolina;SD:South Dakota;TN:Tennessee;TX:Texas;UT:Utah;VT:Vermont;VA:Virginia;WA:Washington;WV:West Virginia;WI:Wisconsin;WY:Wyoming;DC:District of Columbia`
    .split(';')
    .map((pair) => {
        const [value, label] = pair.split(':');
        return { value, label };
    });

/** Map Trinity / API `StatesFullName` entries to Select options (same fields as ContactManageModal). */
export function buildStateOptionsFromMaster(raw: unknown[] | null | undefined): StateOption[] {
    if (!Array.isArray(raw) || raw.length === 0) return [];
    const out: StateOption[] = [];
    for (const item of raw) {
        const o = item as Record<string, unknown>;
        const rawLabel = (o.Text ?? o.Label ?? o.label ?? o.text ?? '') as string;
        const rawValue =
            o.Value !== undefined && o.Value !== null
                ? String(o.Value)
                : o.value !== undefined && o.value !== null
                  ? String(o.value)
                  : o.Id !== undefined && o.Id !== null
                    ? String(o.Id)
                    : String(rawLabel || '').trim();
        const label = String(rawLabel || rawValue).trim() || rawValue;
        const value = String(rawValue).trim();
        if (value) out.push({ value, label });
    }
    return out;
}

/** Pick a Select `value` that exists in `options` from opportunity / install / raw abbrev. */
export function resolveGoodLeapStateValue(preferred: string, options: StateOption[]): string {
    if (!options.length) return preferred.trim();
    const t = preferred.trim();
    if (!t) return options[0].value;
    if (options.some((o) => o.value === t)) return t;
    const hitVal = options.find((o) => o.value.toUpperCase() === t.toUpperCase());
    if (hitVal) return hitVal.value;
    const compact = t.replace(/\s+/g, '').toUpperCase();
    const byLabel = options.find((o) => o.label.replace(/\s+/g, '').toUpperCase() === compact);
    if (byLabel) return byLabel.value;
    return options[0].value;
}

/** Customer preference values aligned with Trinity GoodLeap loan application. */
export const GOODLEAP_CUSTOMER_PREFERENCE_OPTIONS: { value: 'InPerson' | 'Email'; label: string }[] = [
    { value: 'InPerson', label: 'In-Person' },
    { value: 'Email', label: 'Email' },
];
